<template>
      <router-view v-if="info != null"
            :info="info"/>
</template>

<script>
    import UI from '../../helpers/ui-helpers'
    import BackendApi from '../../backendApi'

    let backendApi = new BackendApi();

    export default {
        name: "auth-layout",

        data(){
            return{
                info: null
            }
        },

        mounted() {
            let vm = this;

            backendApi.projectInfo().then(function (response) {
                //console.info('auth-layout -> backendApi.projectInfo, response:', response.data);
                if (response.hasError) {
                    UI.toastr.error('Ошибка при загрузке страницы');
                }
                else {
                    if (response.data != null) {
                        vm.info = response.data;
                    }
                }
            });
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// Content/src/views/shared/AuthLayout.vue